import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PERFORMANCEAPPRAISALDETAIL,
  DELETE_PERFORMANCEAPPRAISALDETAIL,
  UPDATE_PERFORMANCEAPPRAISALDETAIL,
  ADD_NEW_PERFORMANCEAPPRAISALDETAIL,
} from "./actionType";

import {
  getPerformanceAppraisalDetailSuccess,
  getPerformanceAppraisalDetailFail,
  deletePerformanceAppraisalDetailSuccess,
  deletePerformanceAppraisalDetailFail,
  updatePerformanceAppraisalDetailSuccess,
  updatePerformanceAppraisalDetailFail,
  addPerformanceAppraisalDetailSuccess,
  addPerformanceAppraisalDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePerformanceAppraisalDetailApi,
  getPerformanceAppraisalDetailApi,
  updatePerformanceAppraisalDetailApi,
  deletePerformanceAppraisalDetailApi,
  addNewPerformanceAppraisalDetailApi
} from "../../helpers/backend_helper";

function* getPerformanceAppraisalDetail({ payload: performanceAppraisalDetail }) {
  try {
    const response = yield call(getPerformanceAppraisalDetailApi, performanceAppraisalDetail);
    yield put(getPerformanceAppraisalDetailSuccess(GET_PERFORMANCEAPPRAISALDETAIL, response.data));
  } catch (error) {
    yield put(getPerformanceAppraisalDetailFail(GET_PERFORMANCEAPPRAISALDETAIL, error));
  }
}

function* onUpdatePerformanceAppraisalDetail({ payload: performanceAppraisalDetail }) {
  try {
    if (performanceAppraisalDetail.setApprove) {
      const response = yield call(approvePerformanceAppraisalDetailApi, performanceAppraisalDetail);
      yield put(updatePerformanceAppraisalDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePerformanceAppraisalDetailApi, performanceAppraisalDetail);
      yield put(updatePerformanceAppraisalDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePerformanceAppraisalDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePerformanceAppraisalDetail({ payload: performanceAppraisalDetail }) {
  try {
    const response = yield call(deletePerformanceAppraisalDetailApi, performanceAppraisalDetail);
    yield put(deletePerformanceAppraisalDetailSuccess({ performanceAppraisalDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePerformanceAppraisalDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPerformanceAppraisalDetail({ payload: performanceAppraisalDetail }) {
  try {
    const response = yield call(addNewPerformanceAppraisalDetailApi, performanceAppraisalDetail);
    yield put(addPerformanceAppraisalDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPerformanceAppraisalDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPerformanceAppraisalDetail() {
  yield takeEvery(GET_PERFORMANCEAPPRAISALDETAIL, getPerformanceAppraisalDetail);
}

export function* watchUpdatePerformanceAppraisalDetail() {
  yield takeEvery(UPDATE_PERFORMANCEAPPRAISALDETAIL, onUpdatePerformanceAppraisalDetail);
}

export function* watchDeletePerformanceAppraisalDetail() {
  yield takeEvery(DELETE_PERFORMANCEAPPRAISALDETAIL, onDeletePerformanceAppraisalDetail);
}

export function* watchAddNewPerformanceAppraisalDetail() {
  yield takeEvery(ADD_NEW_PERFORMANCEAPPRAISALDETAIL, onAddNewPerformanceAppraisalDetail);
}

function* performanceAppraisalDetailSaga() {
  yield all([
    fork(watchGetPerformanceAppraisalDetail),
    fork(watchDeletePerformanceAppraisalDetail),
    fork(watchUpdatePerformanceAppraisalDetail),
    fork(watchAddNewPerformanceAppraisalDetail)
  ]);
}

export default performanceAppraisalDetailSaga;
